import { useEffect } from "react";
import seo from "@/seo/pages.json";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) return el?.remove();
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: seo.faq.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

// Per-route title, description, canonical, social tags and page JSON-LD.
export function useSeo(pathname) {
  useEffect(() => {
    const page = seo.pages[pathname];
    if (!page) return;
    const url = `${seo.site}${pathname === "/" ? "/" : pathname}`;
    document.title = page.title;
    setMeta("name", "description", page.description);
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", page.title);
    setMeta("name", "twitter:description", page.description);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = url;

    const crumbs = [{ name: "Home", item: `${seo.site}/` }];
    if (pathname.startsWith("/services/")) crumbs.push({ name: "Services", item: `${seo.site}/services` });
    if (pathname !== "/") crumbs.push({ name: page.h1, item: url });
    setJsonLd("seo-breadcrumbs", crumbs.length > 1 ? {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: c.item })),
    } : null);
    setJsonLd("seo-faq", pathname === "/" ? faqJsonLd : null);
  }, [pathname]);
}
